import IndexPage from './IndexPage'

export default [
  {
    path: '/',
    name: 'dashboard',
    component: IndexPage,
  },
]
